<template>
    <div
        v-if="content.title"
        class="pb-2 px-4 pt-10 first:pt-5"
        :class="{
            'border-b border-neutral-subtle text-gray-600 uppercase text-[13px] font-normal tracking-wide': !content.simple,
            'content-sm-ux-medium text-neutral-extra-strong': content.simple && isNextGen,
            'content-sm-extra-strong text-neutral-base': content.simple && !isNextGen,
        }"
    >
        {{ content.title }}
    </div>
    <div
        v-else
        class="h-12 first:h-0"
    />

    <ModuleComponents
        v-if="config.items"
        :modules="config.items"
        :filter="filter"
    />
</template>

<script setup>
    import componentTypes from '@/constants/componentTypes'

    const versionStore = useVersionStore()
    const { isNextGen } = storeToRefs(versionStore)

    defineOptions({
        name: componentTypes.GroupListItem,
        inheritAttrs: false,
    })

    const props = defineProps({
        config: Object,
        filter: Function,
    })

    const content = computed(() => (props.config ? props.config.data : null))
</script>
